import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const VuePouterPush = Router.prototype.push
Router.prototype.push = function push(to){
    return VuePouterPush.call(this,to).catch(err => err)
}

export default new Router({
    routes: [
        { path: '/', redirect: '/index' },
        { path: '/',name: '', component: () =>import ('../components/home/home'),
            children: [ 
                {path: 'index',name: '首页',component: () =>import ('../view/index')},//首页
                {path: 'consultService',name: '咨询服务',component: () =>import ('../view/consultService')},//咨询服务
                {path: 'productCenter',name: '',component: () =>import ('../view/productCenter')},//产品中心
                {path: 'aboutUs',name: '',component: () =>import ('../view/aboutUs')},//关于我们
                {path: 'operation',name: '',component: () =>import ('../view/operation')},//运营服务
            ]
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
    mode:'history',
    // base:'/home/'
})


// WEBPACK FOOTER //
// ./src/router/index.js